import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UITypeInterfaceFormComponent } from 'buzzyears.ui';
import { InputInterfaceVertex, Workflow, TypeData } from 'component.workflow.core';
import { AbstractWorkflowDesignerDispatcherObserver } from './abstract-workflow-designer-dispatcher-observer';
import {
  WorkflowDesignerDispatcherAction,
  WorkflowDesignerDispatcherActionType,
  WorkflowDesignerDispatcherService
} from './workflow-designer-dispatcher.service';

@Component({
  selector: 'wf-designer-test',
  template: `

    <section>
      <h3>Test Workflow</h3>
      <p>Please provide the input details to test the workflow.</p>
      <ui-type-interface-form *ngIf="initialized" [typeData]="typeData" (formSubmit)="onFormSubmit($event)"
                              #interfaceForm>

        <br/><br/>
        <button class="btn btn-outline-success btn-sm float-right" [disabled]="!interfaceForm.valid">Test</button>

      </ui-type-interface-form>
    </section>
  `, styles: [ `

    section {

    }

    h3 {
      margin-top: 0;
    }

  ` ]
})
export class WorkflowDesignerTestComponent extends AbstractWorkflowDesignerDispatcherObserver
  implements OnInit, OnDestroy, OnChanges {

  @Input() workflow: Workflow;

  @ViewChild('interfaceForm') interfaceForm: UITypeInterfaceFormComponent;

  typeData: TypeData;

  constructor(dispatcherService: WorkflowDesignerDispatcherService) {
    super(dispatcherService);
  }

  get initialized(): boolean {
    return !!this.typeData;
  }

  ngOnChanges() {
    this.rebuildTypeData();
  }

  rebuildTypeData(defaultValue: any = null) {
    const typeInterface = this.workflow.getInputTypeInterface();
    this.typeData = typeInterface.toTypeData(typeInterface.defaultObject(defaultValue));
  }

  onFormSubmit(data: any) {
    this.dispatcherService.dispatchAction(WorkflowDesignerDispatcherActionType.WorkflowTestRequest, this, data);
  }

  onDispatcherEvent(action: WorkflowDesignerDispatcherAction) {
    switch (action.type) {
      case WorkflowDesignerDispatcherActionType.VertexRemoved:
      case WorkflowDesignerDispatcherActionType.VertexAdded:
      case WorkflowDesignerDispatcherActionType.VertexPropertiesUpdated:

        if (action.data instanceof InputInterfaceVertex) {
          this.rebuildTypeData(this.interfaceForm.form.value);
        }

        break;
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/library/designer/workflow-designer-test.component.ts